import React, { useEffect, useState } from "react";
import { Flex, FormControl, FormLabel, Heading, Input, Text } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import '@mdxeditor/editor/style.css';
import './TextContentElement.css';
import { useFocus } from "./useFocus";
const defaults = {
    superline: "Lorem ipsum dolor sit amet",
    title: "Lorem ipsum dolor sit amet"
};
function isTitle(element) {
    return element.type === "title";
}
export const TitleContentElement = (props) => {
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    useEffect(() => {
        if (!isTitle(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "title", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isTitle(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Title", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Superline"),
                    React.createElement(Input, { value: props.contentElement.data.superline, onChange: e => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { superline: e.target.value }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Title"),
                    React.createElement(Input, { value: props.contentElement.data.title, onChange: e => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { title: e.target.value }) })) }))),
        React.createElement(Flex, { flexDirection: "column", alignItems: "center", gap: 0, flex: 1 },
            React.createElement(Text, { textTransform: "uppercase", fontWeight: "bold", textAlign: "center", color: "gray.600" }, props.contentElement.data.superline),
            React.createElement(Heading, { fontSize: "4xl", lineHeight: 1.5, fontWeight: "black", textAlign: "center", bgGradient: 'linear(to-br, brand.400, brand.600)', bgClip: "text" }, props.contentElement.data.title))));
};
